import React, { useContext, useEffect, useState } from 'react';
import axiosInstance from '../../api/axiosInstance';
import { AuthContext } from '../../context/AuthContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './UserProf.css';

function UserPro() {
  const { authData, setAuthData } = useContext(AuthContext);
  const [name, setName] = useState(authData?.name || '');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setName(authData?.name || '');
  }, [authData]);

  const handleNameUpdate = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const res = await axiosInstance.put(`/users/${authData._id}`, { name });
      toast.success('Username updated successfully.');

      if (setAuthData) {
        setAuthData(prev => ({
          ...prev,
          name: res.data.name,
        }));
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to update username');
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordChange = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmNewPassword) {
      toast.error("New passwords don't match");
      return;
    }

    if (newPassword.length < 6) {
      toast.error('New password must be at least 6 characters');
      return;
    }

    try {
      setLoading(true);
      await axiosInstance.patch(`/users/${authData._id}/password`, {
        currentPassword,
        newPassword,
      });

      toast.success('Password updated successfully');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmNewPassword('');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to update password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="profile-container">
      <h2>User Profile</h2>

      <div className="card">
        <h3>Update Username</h3>
        <form onSubmit={handleNameUpdate}>
          <div className="form-group">
            <label>Email (readonly)</label>
          
            <p className="email-text" readonly>{authData?.email} </p>
          </div>

          <div className="form-group">
            <label>Username</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="butn" disabled={loading}>
            {loading ? 'Saving...' : 'Update Username'}
          </button>
        </form>
      </div>

      <div className="card">
        <h3>Change Password</h3>
        <form onSubmit={handlePasswordChange}>
          <div className="form-group">
            <label>Current Password</label>
            <input
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>New Password</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Confirm New Password</label>
            <input
              type="password"
              value={confirmNewPassword}
              onChange={(e) => setConfirmNewPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="butn" disabled={loading}>
            {loading ? 'Updating...' : 'Change Password'}
          </button>
        </form>
      </div>

      {/* Toast container to show notifications */}
      
    </div>
  );
}

export default UserPro;
